export const getTimesWord = (n: number): string => {
    const abs = Math.abs(n);
    const lastDigit = abs % 10;
    const lastTwoDigits = abs % 100;

    if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
        return "разів";
    }

    if (lastDigit === 1) {
        return "раз";
    }

    if (lastDigit >= 2 && lastDigit <= 4) {
        return "рази";
    }

    return "разів";
};

export const getTotalGifts = (gifts: Record<string, number>) =>
    Object.values(gifts).reduce((acc, val) => acc + (val || 0), 0);
